import gql from 'graphql-tag';

export const GET_ORDER = gql`
  query getOrder($id: ID!) {
    order(id: $id) {
      amountOutstanding
      appointments {
        id
        serviceNames
        startAt
        discountCode {
          id
          code
          discountAmount
          discountPercentage
          discountType
          serviceIds
        }
      }
      cashupId
      customer {
        email
        firstName
        fullName
        id
        lastName
        mobilePhone
        phone
        picture
        blocked
      }
      compliantRegister
      draft
      fiscalizationFinished
      id
      invoicedAt
      items {
        description
        employee {
          id
          name
        }
        id
        price
        quantity
        originalPrice
        loyaltyPointsAmount
        usedPrepaidCard {
          id
          description
        }
        servicePackageService {
          id
        }
      }
      location {
        internalName
      }
      medical
      number
      employeeNames
      tipAmount
      permissions {
        credit
        delete
        edit
        editOrderItems
        issueInvoice
      }
      state
      total
      transactions {
        id
        description
        amount
        deletable
        giftcard {
          code
        }
        prepaidCard {
          id
          description
        }
        type
        transactionAt
      }
      comments
      documents {
        id
        documentType
        number
        totalAmountInclTaxExempt
        issuedAt
        referencedDocuments {
          id
          number
          documentType
        }
      }
    }
  }
`;

export const DELETE_ORDER = gql`
  mutation deleteOrder($input: DeleteOrderInput!) {
    deleteOrder(input: $input) {
      order {
        id
      }
    }
  }
`;

export const UPDATE_ORDER = gql`
  mutation updateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      order {
        id
        comments
      }
      errors
    }
  }
`;
